import { render, staticRenderFns } from "./task-profile.vue?vue&type=template&id=43cbaf80&scoped=true"
import script from "./task-profile.vue?vue&type=script&lang=js"
export * from "./task-profile.vue?vue&type=script&lang=js"
import style0 from "./task-profile.vue?vue&type=style&index=0&id=43cbaf80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cbaf80",
  null
  
)

export default component.exports